import toast from 'react-hot-toast'
import { Button } from 'components/common'
import { ExportIcon } from 'components/icons'
import { exportAreasList } from 'utils/api/ares'

const ExportAreasButton = () => {
  const downloadCsv = async () => {
    const loadingToast = toast.loading('Loading..')
    try {
      await exportAreasList()
      toast.success('File will be sent to you in email!', { id: loadingToast })
    } catch (error) {
      toast.error('File Downloading Failed.', { id: loadingToast })
    }
  }

  return (
    <Button
      type="button"
      buttonText="Export"
      variant="custom"
      iconClassName="!h-5 !w-5 text-dataTableIcon"
      icon={<ExportIcon />}
      className="rounded-lg px-3.5 py-2 text-sm font-semibold text-sidebar-primary hover:bg-gray-200"
      onClick={downloadCsv}
    />
  )
}

export default ExportAreasButton
